import { render, staticRenderFns } from "./NewEditCircuitoNotasPage.vue?vue&type=template&id=0526cd8c"
import script from "./NewEditCircuitoNotasPage.vue?vue&type=script&lang=js"
export * from "./NewEditCircuitoNotasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports